import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { startTranslator } from './i18n';

startTranslator();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// PWA Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => {
        console.log('Starhub Creative SW registered');
        reg.onupdatefound = () => {
          const sw = reg.installing;
          sw.onstatechange = () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              sw.postMessage({ type: 'SKIP_WAITING' });
              window.location.reload();
            }
          };
        };
      })
      .catch(err => console.error('SW error:', err));
  });
}

// Install prompt
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window._smInstallPrompt = e;
});
